export default __webpack_public_path__ + "static/media/coins.0b9c9be5.svg";